import React from "react"
import { AppFunctionComponent } from "../../../types"
import StickySubmenu from "../../components/sticky-submenu/sticky-submenu.component"
import { SubmenuItem } from "../../types/menu.interface"
import { BasicButtonLink } from "../../../ui/components/link/link.component"

interface Props {
  navigationItems: SubmenuItem[]
  pathname: string
}

const Submenu: AppFunctionComponent<Props> = ({
  navigationItems,
  className,
  pathname,
}) => {
  return (
    <>
      {navigationItems.map(({ subnavigationItem }) => {
        return (
          subnavigationItem &&
          subnavigationItem.map((submenu) => {
            const { displayName, path, button, subnavigationItem } = submenu

            return (
              pathname.startsWith(path + "/") &&
              !pathname.includes("find-your-best-fit") &&
              !pathname.includes("kompakt/quick-start") &&
              subnavigationItem && (
                <StickySubmenu
                  key={submenu.path}
                  className={className}
                  title={displayName}
                  titleUrl={path}
                  items={subnavigationItem}
                  button={
                    button ? (
                      <BasicButtonLink
                        className={className}
                        to={button.url}
                        aria-label={button.context}
                      >
                        {button.text}
                      </BasicButtonLink>
                    ) : null
                  }
                />
              )
            )
          })
        )
      })}
    </>
  )
}

export default Submenu
